var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cup-wrapper",on:{"click":_vm.roll}},[_c('img',{class:['cup', _vm.onScreen ? 'show' : null, _vm.wiggle ? 'wiggle' : null],attrs:{"src":_vm.url}})])}
var staticRenderFns = []

export { render, staticRenderFns }